import styled from "styled-components";

interface isActive {
    active?: boolean;
}

export const HeaderComponent = styled.div`
    width: 100%;
    margin-top: 1%;
    display: flex;
    background-color: var(--setra-blue);
    height: 60px;
    @media only screen and (max-width: 1000px) {
        height: 80px;
    }
`;

export const HeaderContent = styled.div`
    display: flex;
    width: 100%;
`;

export const LogoDiv = styled.div``;

export const Logo = styled.img`
    display: flex;
    align-items: center;
`;

export const NavMenu = styled.div`
    display: flex;
    text-align: center;
    align-items: center;
    font-size: 16px;
    font-family: "Poppins";
    margin: 0% 2%;
    color:  white;
    font-weight: 600;
`;

export const NavItem = styled.span<isActive>`
    cursor: pointer;
    padding: 0 10px;
    text-decoration: ${(props) => (props.active ? 'underline' : 'none')};
    text-decoration-thickness: 4px;
    text-underline-offset: 3px;
    /* text-decoration-color: #95246D; */
    color: ${(props) => (props.active ? 'var(--light-setra-blue)' : 'inherit')};

    &:hover {
        text-decoration: underline;
        text-decoration-thickness: 4px;
        /* text-decoration-color: #95246D; */
        text-underline-offset: 3px;
        color: var(--light-setra-blue);
        font-size: 18px;
    }
`;

export const SearchDiv = styled.div``;

export const MobileDiv = styled.div`
    margin: 0px 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: left;
    h1 {
        color: white;
    }
`;

export const IconsDiv = styled.div`
    padding: 1px;
`;
